import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  projects: []
};
const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setProjects(state, action) {
      state.projects = action.payload;
    }
  }
});
export const { setProjects } = projectsSlice.actions;
export default projectsSlice.reducer;
export const fetchProjects = () => async (dispatch) => {
  try {
    const response = await fetch(
      "https://sriragavip.github.io/pp/port/project.json"
    );
    const data = await response.json();
    dispatch(setProjects(data));
  } catch (error) {
    console.error("Error fetching projects:", error);
  }
};
